import React, { Component } from 'react';
import { Card, CardHeader, CardBody, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText, Badge } from 'reactstrap';

import './sidebar.scss';

class Sidebar extends Component {
    render() {
        return (
            <div className="app-sidebar">
                <Card className="pb-3 border-bottom">
                    <CardHeader className="bg-light text-primary app-sidebar__header">
                        Portfolio Alerts <Badge color="danger" className="d-none d-sm-inline-block">4</Badge>
                        <time className="d-block app-sidebar__header-datetime">Today August 31, 2018</time>
                    </CardHeader>
                    <CardBody>
                        <ListGroup>
                            <ListGroupItem>
                                <ListGroupItemHeading>
                                    <a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Rs 4,000 crore Debt: Telecom Tower Co Seeks To Stall Bankruptcy Bid</a>
                                </ListGroupItemHeading>
                                <ListGroupItemText>
                                    Pune News
                                </ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading>
                                    <a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Rs 4,000 crore Debt: Telecom Tower Co Seeks To Stall Bankruptcy Bid</a>
                                </ListGroupItemHeading>
                                <ListGroupItemText>
                                    Pune News
                                </ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading>
                                    <a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Rs 4,000 crore Debt: Telecom Tower Co Seeks To Stall Bankruptcy Bid</a>
                                </ListGroupItemHeading>
                                <ListGroupItemText>
                                    Pune News
                                </ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading>
                                    <a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Rs 4,000 crore Debt: Telecom Tower Co Seeks To Stall Bankruptcy Bid</a>
                                </ListGroupItemHeading>
                                <ListGroupItemText>
                                    Pune News
                                </ListGroupItemText>
                            </ListGroupItem>
                        </ListGroup>
                    </CardBody>
                </Card>
                <Card className="pb-3">
                    <CardHeader className="bg-light text-primary app-sidebar__header">
                        News Feeds
                        <time className="d-block app-sidebar__header-datetime">Today August 31, 2018</time>
                    </CardHeader>
                    <CardBody>
                        <ListGroup>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                            <ListGroupItem>
                                <ListGroupItemHeading><a href="https://economictimes.indiatimes.com/" target="_blank" rel="noopener noreferrer">Infosys CEO Vishal Sikka resigns</a></ListGroupItemHeading>
                                <ListGroupItemText>CNBC News</ListGroupItemText>
                            </ListGroupItem>
                        </ListGroup>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default Sidebar;

